<div class="container margin">
  <form
    [formGroup]="formAreas"
    (ngSubmit)="formAreas.valid ? save(formAreas.value) : errorMessage()"
  >
    <div style="flex-direction: column; display: flex">
      <file-input
        style="width: 100%; padding: 30px"
        [params]="fileInput"
        (fileSave)="fileChange($event)"
      ></file-input>

      <div style="display: flex; width: 100%">
        <div style="flex: 12">
          <div class="first-row">
            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  matInput
                  #nombre
                  maxlength="255"
                  formControlName="nombre"
                  placeholder="Nombre"
                  required
                />
                <mat-hint>{{ nombre.value.length }}/255</mat-hint>
                <mat-error>Campo requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="row-item">
              <!-- responsable -->
              <combos
                [configuration]="combosConfigUser"
                [reloadCombo]="reloadComboUser"
                [required]="true"
                [filter]="true"
                (changeOption)="ValueIDUser($event)"
              >
              </combos>
            </div>
          </div>

          <div class="default-row">
            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  matInput
                  #codigo
                  maxlength="255"
                  formControlName="codigo"
                  placeholder="Código"
                />
                <mat-hint>{{ codigo.value.length }}/255</mat-hint>
              </mat-form-field>
            </div>

            <div class="row-item">
              <mat-form-field>
                <input
                  autocomplete="off"
                  type="text"
                  matInput
                  #descripcion
                  maxlength="1024"
                  formControlName="descripcion"
                  placeholder="Descripción"
                />
                <mat-hint>{{ descripcion.value.length }}/1024</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div style="flex: 0.2">
          <button mat-mini-fab color="warn" type="submit">
            <mat-icon>save</mat-icon>
          </button>

          <button
            *ngIf="tipoRedireccion == 'actualizar'"
            mat-mini-fab
            color="accent"
            style="margin-top: 10px"
            (click)="deleteArea($event)"
          >
            <mat-icon>delete</mat-icon>
          </button>

          <button
            mat-mini-fab
            color="primary"
            (click)="back($event)"
            style="margin-top: 10px"
          >
            <mat-icon>reply</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
